<div class="console-page">

  <div class="console-content">

    <app-page-header

      title="Generador por lote F5"

      description="Genera archivos por lote. Configurá, subí Excel o agregá registros manualmente."

    ></app-page-header>



    <app-console-section title="Configuración">

      <div class="console-form-grid">

        <div class="console-field">

          <label class="console-field__label" for="fileName">Nombre del archivo</label>

          <input type="text" id="fileName" class="console-input" [(ngModel)]="fileName" placeholder="Nombre del archivo" />

          <span class="console-field__hint">Nombre del archivo que se generará</span>

        </div>

      </div>

    </app-console-section>



    <app-console-section title="Consulta">

      <p class="console-section__desc">Sube un archivo Excel con el <strong>Formato carga masiva</strong> (mismas columnas que la tabla de abajo).</p>

      <div class="file-upload-wrap">

        <input type="file" #excelInput id="excelInput" accept=".xlsx,.xls" (change)="onExcelSelected($event)" class="file-input" [disabled]="isLoadingExcel">

        <label for="excelInput" class="file-label" [class.file-label-loading]="isLoadingExcel">

          <span class="file-label-text">{{ isLoadingExcel ? 'Cargando...' : (excelFileName || 'Seleccionar Archivo Excel') }}</span>

        </label>

      </div>

      <div class="loading loading-excel" *ngIf="isLoadingPreview">

        <div class="spinner"></div>

        <p>Consultando API...</p>

      </div>

    </app-console-section>



    <app-console-section title="Registros de transacciones">

      <p class="console-field__hint">({{ records.length }} registros)</p>



      <div class="loading loading-excel" *ngIf="isLoadingExcel">

        <div class="spinner"></div>

        <p>Cargando registros...</p>

      </div>



      <div class="table-wrap" *ngIf="!isLoadingExcel && records.length > 0">

        <table class="records-table">

          <thead>

            <tr>

              <th>#</th>

              <th>Cód. Comercio</th>

              <th>Referencia</th>

              <th>Nro. Lote</th>

              <th>Tipo Op.</th>

              <th>Nro. Tarjeta</th>

              <th>Tipo Tarjeta</th>

              <th>Fecha Transac.</th>

              <th>Fecha Proceso</th>

              <th>Fecha Abono</th>

              <th>Importe Transac.</th>

              <th>Desc. Movimiento</th>

              <th>Comisión Visa</th>

              <th>Comisión IGV</th>

              <th>Importe Neto</th>

              <th>Tipo Captura</th>

              <th>Estado Abono</th>

              <th>Cuenta Bancaria</th>

              <th>Cód. Autoriz.</th>

              <th>ID Único Transac.</th>

              <th>Nro. Serie Terminal</th>

              <th>Nro. Cuota</th>

              <th>Importe Cashback</th>

              <th>Espacios Blanco</th>

              <th>ID Único Transac. 2</th>

            </tr>

          </thead>

          <tbody>

            <tr *ngFor="let record of records; let i = index">

              <td>{{ i + 1 }}</td>

              <td>{{ record.codigoComercio || '—' }}</td>

              <td>{{ record.referencia || '—' }}</td>

              <td>{{ record.numeroLote || '—' }}</td>

              <td>{{ record.tipoOperacion || '—' }}</td>

              <td>{{ record.numeroTarjeta || '—' }}</td>

              <td>{{ record.tipoTarjeta || '—' }}</td>

              <td>{{ record.fechaTransaccion || '—' }}</td>

              <td>{{ record.fechaProceso || '—' }}</td>

              <td>{{ record.fechaAbono || '—' }}</td>

              <td>{{ record.importeTransaccion !== undefined && record.importeTransaccion !== null ? record.importeTransaccion : '—' }}</td>

              <td>{{ record.descuentoMovimiento !== undefined && record.descuentoMovimiento !== null ? record.descuentoMovimiento : '—' }}</td>

              <td>{{ record.comisionVisa !== undefined && record.comisionVisa !== null ? record.comisionVisa : '—' }}</td>

              <td>{{ record.comisionIgv !== undefined && record.comisionIgv !== null ? record.comisionIgv : '—' }}</td>

              <td>{{ record.importeNeto !== undefined && record.importeNeto !== null ? record.importeNeto : '—' }}</td>

              <td>{{ record.tipoCaptura || '—' }}</td>

              <td>{{ record.estadoAbono || '—' }}</td>

              <td>{{ record.cuentaBancaria || '—' }}</td>

              <td>{{ record.codigoAutorizacion || '—' }}</td>

              <td>{{ record.idUnicoTransaccion || '—' }}</td>

              <td>{{ record.numeroSerieTerminal || '—' }}</td>

              <td>{{ record.numeroCuota !== undefined && record.numeroCuota !== null ? record.numeroCuota : '—' }}</td>

              <td>{{ record.importeCashback !== undefined && record.importeCashback !== null ? record.importeCashback : '—' }}</td>

              <td>{{ record.espaciosBlanco || '—' }}</td>

              <td>{{ record.idUnicoTransaccion2 || '—' }}</td>

            </tr>

          </tbody>

        </table>

      </div>



      <div class="empty-state" *ngIf="!isLoadingExcel && records.length === 0">

        No hay registros. Subí un Excel con columna Token o formato carga masiva.

      </div>

    </app-console-section>



    <app-console-section title="Exportar">

      <div class="loading" *ngIf="isLoading">

        <div class="spinner"></div>

        <p>Generando archivo...</p>

      </div>

      <div class="status" [ngClass]="statusClass" *ngIf="statusMessage">

        {{ statusMessage }}

      </div>

      <div class="console-actions">

        <button type="button" class="console-btn console-btn--primary" (click)="exportF5()" [disabled]="isLoading || records.length === 0">Exportar F5</button>

        <button type="button" class="console-btn" (click)="clearAll()">Limpiar todo</button>

      </div>

    </app-console-section>

  </div>

</div>

